import React, { useMemo } from 'react'

import Cookies from 'js-cookie'

const DEFAULT_OFFSET = 74

const DefaultContainer = ({ children, useTabs = true }) => {
  const useSwitchUser = useMemo(() => !!Cookies.get('switch_user_id'), [Cookies.get('switch_user_id')])
  const switchUserOffset = useMemo(() => (useSwitchUser ? 41 : 0), [useSwitchUser])
  const tabsOffset = useMemo(() => (useTabs ? 65 : 0), [useTabs])

  const height = useMemo(() => `calc(100vh - ${switchUserOffset + tabsOffset + DEFAULT_OFFSET}px)`, [switchUserOffset, tabsOffset])

  return (
    <div className='default-container flex-column' style={{ height }}>
      {children}
    </div>
  )
}

export default DefaultContainer
